import apiEndpoints from '../../const/apiEndpoints'
import api from '../../services'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { UserDetail, UserPayload } from './types'
import history from '../../const/history'
import AdminType from '../../const/admin'
import { getAdminList } from '../coachingCenter/actions'
import { RootState } from '../store'
import getRoleId from '../../helpers/getRoleId'
import { clearLogin } from '../user/api'

export const saveUserDetail = createAsyncThunk(
  'userDetail/save',
  async (requestPayload: UserDetail, { dispatch }): Promise<UserDetail> => {
    const { data } = await api.post(
      `${apiEndpoints.saveUserDetail}`,
      requestPayload
    )

    if (data) {
      dispatch(getAdminList({ type: requestPayload.userType as AdminType }))
      history.goBack()
    }
    return data
  }
)

export const editUserDetail = createAsyncThunk(
  'userDetail/edit',
  async (requestPayload: UserDetail, { dispatch }): Promise<UserDetail> => {
    const { id, userType } = requestPayload
    const { data } = await api.put(
      `${apiEndpoints.editUserDetail}${id}`,
      requestPayload
    )

    if (data) {
      dispatch(clearLogin())
      dispatch(getAdminList({ type: userType as AdminType }))
      history.goBack()
    }
    return data
  }
)

export const deleteUserDetail = createAsyncThunk(
  'userDetail/delete',
  async (
    requestPayload: UserPayload,
    { dispatch }
  ): Promise<Array<UserDetail>> => {
    const { id, type } = requestPayload
    const response = await api.delete(`${apiEndpoints.deleteUserDetail}${id}`)
    dispatch(getAdminList({ type }))
    if (response.data) {
      dispatch(clearLogin())
    }
    return response?.data
  }
)

export const addNewStudentDetails = createAsyncThunk(
  'student/saveStudent',
  async (_undefined, { getState, rejectWithValue }): Promise<any> => {
    const {
      userDetail: {
        studentInformation: {
          admissionType,
          coachingCenterId,
          courseId,
          batchIds,
          branchIds,
          lang1,
          lang2,
          studentName,
          fathersName,
          mothersName,
          gender,
          nationality,
          religion,
          caste,
          country,
          challenged,
          community,
          address,
          aadhar,
          studentType,
          email,
          city,
          taluk,
          parentNumber,
          district,
          state,
          dob,
          passwordUpdated,
          zipCode,
          percentage,
          medium,
          statNo,
          board,
          yearOfPassing,
          markObtained,
          regNo,
          lastAttended,
          academicYear,
          enrollmentNumber
        }
      }
    } = getState() as RootState

    if (
      coachingCenterId &&
      admissionType &&
      courseId &&
      batchIds &&
      fathersName &&
      mothersName &&
      branchIds &&
      studentName &&
      gender &&
      nationality &&
      religion &&
      address &&
      aadhar &&
      country &&
      email &&
      city &&
      taluk &&
      district &&
      state &&
      dob &&
      parentNumber &&
      passwordUpdated &&
      academicYear &&
      zipCode
    ) {
      const requestPayload = {
        coachingCenterId: coachingCenterId,
        courseId: courseId,
        admissionType,
        branchIds: branchIds,
        batchIds: batchIds,
        lang1: lang1 || '',
        lang2: lang2 || '',
        studentName: studentName,
        aadhar: aadhar || '',
        caste: caste || '',
        religion: religion,
        community,
        nationality,
        gender,
        challenged: challenged === 'yes',
        studentTpe: studentType,
        address,
        zipCode: zipCode,
        email,
        country: country,
        enrollmentNumber: enrollmentNumber,
        parentNumber: parentNumber,
        district,
        taluk,
        city,
        state,
        dob: dob,
        medium,
        regNo: regNo,
        statNo: statNo,
        board,
        lastAttended: lastAttended,
        yearOfPassing: yearOfPassing,
        markObtained: markObtained,
        percentage: percentage,
        passwordUpdated: passwordUpdated,
        status: 'ACTIVE',
        userType: AdminType.STUDENT,
        roleId: getRoleId(AdminType.STUDENT),
      }
      const response = await api.post(
        apiEndpoints.studentRegistration,
        requestPayload
      )
      if (response) {
        history.goBack()
      }
      return response?.data
    } else {
      return rejectWithValue("strings?.validationMessages?.studentRegistration")
    }
  }
)